import { SparkLineData } from '../types'

/**
 * Basic legend label, just returns the line's key as it's label
 */
export const getLegendLabel = ({ key }: SparkLineData): string => key
